import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingSpinner = ({ size = 'md', text = 'Loading...', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <Loader2 className={`${sizeClasses[size]} text-[hsl(var(--brand-primary))] animate-spin`} />
      {text && <span className="text-[hsl(var(--text-secondary))] text-sm">{text}</span>}
    </div>
  );
};

export const PageLoader = ({ text = 'Loading...' }) => (
  <div className="min-h-[400px] flex items-center justify-center">
    <LoadingSpinner size="lg" text={text} />
  </div>
);

export const ButtonLoader = ({ text = 'Processing...' }) => (
  <span className="flex items-center gap-2">
    <Loader2 className="w-4 h-4 animate-spin" />
    {text}
  </span>
);

export const SkeletonCard = () => (
  <div className="bg-white border border-[hsl(var(--border))] rounded-xl p-6 animate-pulse">
    <div className="h-32 bg-gray-200 rounded-lg mb-4" />
    <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
    <div className="h-3 bg-gray-200 rounded w-1/2" />
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="bg-white border border-[hsl(var(--border))] rounded-xl overflow-hidden animate-pulse">
    <div className="p-4 border-b border-[hsl(var(--border))]">
      <div className="h-6 bg-gray-200 rounded w-1/4" />
    </div>
    <div className="p-4 space-y-3">
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex gap-4">
          {[...Array(cols)].map((_, j) => (
            <div key={j} className="h-4 bg-gray-200 rounded flex-1" />
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default LoadingSpinner;
